import { Link } from "react-router-dom";
import BlockShell from "./BlockShell";
import { absUrl } from "./media";

const isExt = (u) => /^https?:/i.test(u || "");

const TimelineBlock = ({ block }) => {
  const cfg = block.config || {};
  const items = cfg.items || [];
  const accent = cfg.accent || "#F59E0B";
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-8" data-testid="fest-timeline">
    <BlockShell block={block}>
      <ol className="relative border-l-2 ml-3 space-y-8" style={{ borderColor: accent }}>
        {items.map((t, i) => {
          const linkCls = "inline-flex items-center gap-1 text-xs font-bold underline underline-offset-2 mt-2";
          return (
            <li key={i} className={`pl-8 relative ${t.highlight ? "-ml-[2px] pl-[34px]" : ""}`} data-testid={`timeline-item-${i}`}>
              <span className="absolute -left-[11px] top-1 h-5 w-5 rounded-full border-4 border-[#F9F8F6]" style={{ background: t.color || accent }} />
              <div className="flex flex-col sm:flex-row sm:items-start gap-3">
                {t.image && <img src={absUrl(t.image)} alt="" loading="lazy" className="h-16 w-16 rounded-xl object-cover bg-white border border-[#E2E0DC] shrink-0" />}
                <div className="min-w-0">
                  <div className="text-xs font-extrabold uppercase tracking-widest" style={{ color: t.color || "#B45309" }}>{t.when}</div>
                  <div className="font-extrabold text-[#1A1A1A] text-lg leading-tight">{t.title}</div>
                  {t.detail && <p className="text-sm text-[#3a3a3a] max-w-2xl mt-1 whitespace-pre-line">{t.detail}</p>}
                  {t.link && (isExt(t.link)
                    ? <a href={t.link} target="_blank" rel="noopener noreferrer" className={linkCls} style={{ color: t.color || "#B45309" }} data-testid={`timeline-link-${i}`}>{t.link_label || "Open"} →</a>
                    : <Link to={t.link} className={linkCls} style={{ color: t.color || "#B45309" }} data-testid={`timeline-link-${i}`}>{t.link_label || "Open"} →</Link>)}
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </BlockShell>
    </section>
  );
};

export default TimelineBlock;
